import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { useAppState } from '@/store/context';
import { useBootstrap } from '@/auth/bootstrap-context';
import TutorialSpotlight from '@/common/components/tutorial-spotlight';
import TopBar from '@/modules/navigation/top-bar';
import BottomBar from '@/modules/navigation/bottom-bar';
import BudgetSettingsModal from '@/modules/budget/modal-edit-form';
import ModalDeleteForm from '@/modules/budget/modal-delete-form';
import DashboardView from '@/modules/categories-dashboard/dashboard-view';
import style from './style.module.scss';
const DASH_STEPS = [
    {
        title: 'Фильтр пустых категорий',
        text: 'Включите чтобы видеть категории без операций за период. Полезно для планирования.',
        selector: '[data-tut="dash-controls"]',
        place: 'bottom',
    },
    {
        title: 'Сводка по бюджету',
        text: 'Нетто план, факт и остаток за выбранный период. Учитывает доходы минус расходы и накопления.',
        selector: '[data-tut="dash-summary"]',
        place: 'bottom',
    },
    {
        title: 'Таблица категорий',
        text: 'Категории сгруппированы по типам: доходы, расходы, накопления. Нажмите на строку — откроется детальная панель. Перетаскивайте строки для изменения порядка.',
        selector: '[data-tut="dash-body"]',
        place: 'left',
    },
    {
        title: 'Переключение периода',
        text: 'Месяц показывает детали за один месяц, год — суммы за все 12 месяцев.',
        selector: '[data-tut="view-toggle"]',
        place: 'bottom',
    },
];
function DashboardPage() {
    const { budgetId } = useParams();
    const { state, dispatch } = useAppState();
    const navigate = useNavigate();
    const bootstrap = useBootstrap();
    const canImportStatement = bootstrap.data?.storagePolicy?.statementImportEnabled === true;
    const budget = state.budgets.find((b) => b.id === budgetId);
    useEffect(() => {
        if (budgetId && state.currentId !== budgetId) {
            dispatch({ type: 'SET_CURRENT_BUDGET', id: budgetId });
        }
    }, [budgetId, state.currentId, dispatch]);
    const [showSettings, setShowSettings] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const { year, month, calMode } = state;
    const navPrev = () => calMode === 'year'
        ? dispatch({ type: 'NAV_YEAR', delta: -1 })
        : dispatch({ type: 'NAV_MONTH', delta: -1 });
    const navNext = () => calMode === 'year'
        ? dispatch({ type: 'NAV_YEAR', delta: 1 })
        : dispatch({ type: 'NAV_MONTH', delta: 1 });
    if (!budget)
        return _jsx(Navigate, { to: "/app", replace: true });
    return (_jsxs("div", { className: style['dashboard-page'], children: [_jsx(TopBar, { icon: budget.icon || '💼', title: budget.name, year: year, month: month, calMode: calMode, budgetView: "dashboard", onHome: () => navigate('/app'), onSettings: () => setShowSettings(true), onImport: canImportStatement ? () => navigate(`/bdgts/${budgetId}/import`) : undefined, onToggleView: () => navigate(`/bdgts/${budgetId}/cal`), onSetMode: (mode) => dispatch({ type: 'SET_MODE', mode }), onNavPrev: navPrev, onNavNext: navNext }), _jsx(DashboardView, { budget: budget, year: year, month: month, mode: calMode, currency: budget.currency }), _jsx(BottomBar, { items: [
                    { key: 'home', icon: 'home', label: 'Бюджеты' },
                    { key: 'calendar', icon: 'calendar', label: 'Календарь' },
                    { key: 'dashboard', icon: 'dashboard', label: 'Категории' },
                ], activeKey: "dashboard", onSelect: (key) => {
                    if (key === 'home')
                        navigate('/app');
                    if (key === 'calendar')
                        navigate(`/bdgts/${budgetId}/cal`);
                } }), showSettings && (_jsx(BudgetSettingsModal, { budget: budget, onClose: () => setShowSettings(false), onSave: (updates) => {
                    dispatch({ type: 'UPDATE_BUDGET', id: budget.id, updates });
                    setShowSettings(false);
                }, onDelete: () => {
                    setShowSettings(false);
                    setShowDelete(true);
                } })), showDelete && (_jsx(ModalDeleteForm, { budgetName: budget.name, onClose: () => setShowDelete(false), onDelete: () => {
                    dispatch({ type: 'DELETE_BUDGET', id: budget.id });
                    navigate('/app');
                } })), _jsx(TutorialSpotlight, { steps: DASH_STEPS, storageKey: "tut_dashboard_v1" })] }));
}
export default DashboardPage;
